<div class="dynamic-form" [ngSwitch]="activePage">
    <div *ngSwitchCase="PAGES.LOADING"><cm-preloader class="loader"></cm-preloader></div>
    <div *ngSwitchCase="PAGES.MAIN_START">
        <div class="modal-body">
            <cm-display-html class="step-description" [content]="step.description"></cm-display-html>
            <cm-step-on-behalf-list
                *ngIf="step.on_behalf_indicator"
                [onBehalfIndicator]="step.on_behalf_indicator"
            ></cm-step-on-behalf-list>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-default" (click)="dismissModal()">CLOSE</button>
            <button
                type="button"
                class="btn btn-primary"
                [disabled]="step?._userActionsDisabled || step?.isUpcoming"
                (click)="goToPage(PAGES.COMPLETE_FORM)"
            >
                Complete now
            </button>
        </div>
    </div>
    <div *ngSwitchCase="PAGES.COMPLETE_FORM">
        <cm-complete-content
            [step]="step"
            [isStepSubmitted]="isStepSubmitted"
            [registrationFormFields]="registrationFormFields"
            [formData]="formData"
            (screenChange)="goToPage($event)"
            (formSubmit)="onFormSubmit($event)"
        >
        </cm-complete-content>
    </div>
    <div *ngSwitchCase="PAGES.CONFIRM_FORM">
        <cm-confirm-content [step]="step" (backToForm)="backToCompleteForm()" (confirm)="onFormConfirm()">
        </cm-confirm-content>
    </div>
</div>
